<template>
  <div class="content_all2" id="chpass">
    <div class="content_box">
      <div class="list_box w500">
        <div class="y_ititle"><i class="fa fa-lock mr5" aria-hidden="true"></i>變更密碼</div>
        <div class="mt5 mb5">
          <input name="" type="text" class="input_style" placeholder="輸入新密碼" v-model="newPassword1">
        </div>
        <div class="mt5 mb5">
          <input name="" type="text" class="input_style" placeholder="再次輸入新密碼" v-model="newPassword2">
        </div>
        <div class="mt5 mb5">
          <vue-recaptcha ref="recaptcha" @verify="onVerify" sitekey="6LervDYUAAAAAGFkOwdryvivr3SOXgxDt9505Dop"></vue-recaptcha>
        </div>
        <div class="tomi mt15">
          <button type="submit" class="btn_m" @click="changePassword">送出</button>
          <button type="submit" class="btn_n" @click="goBack">回上一頁</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message } from '@/assets/project_setting/config';
import { GetErrorHandler, PostErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';
import VueRecaptcha from 'vue-recaptcha';


export default {
  name: 'chpass',
  components: {
    VueRecaptcha
  },
  data() {
    return {
      jwt: this.$route.query.jwt,
      account: sessionStorage.Account,
      newPassword1: '',
      newPassword2: '',
      verifycode: ''
    };
  },

  methods: {
    onSubmit: function() {
      this.$refs.invisibleRecaptcha.execute()
    },
    onVerify: function(response) {
      this.verifycode = response
      console.log(this.verifycode)
    },

    verify() {
      if (!this.verifycode) {
        throw new Error('請勾選驗證');
      }
    },
    changePassword() {
      try {
        this.checkNewPassword1()
        this.checkNewPassword2()
        this.verify();
      } catch (error) {
        alert(error.message);
        return;
      }
      let form = new FormData();

      form.append('jwt', this.jwt);
      form.append('password', this.newPassword1);

      this.$Message.loading({ content: '儲存中...', duration: 0 });

      axios.post(API.rent_password, form, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          this.$Message.destroy();
          ShowMessage(Message.SaveSuccessfully[sessionStorage.locale]);
          this.$router.push({ name: 'home' });
        })
        .catch(error => {
          this.$Message.destroy();
          PostErrorHandler.bind(this)(error, 'rent_password');
        });

    },
    checkNewPassword1() {
      if (!this.newPassword1) {
        throw new Error('請輸入新密碼');
      }
    },
    checkNewPassword2() {
      if (!this.newPassword2) {
        throw new Error('請再次輸入新密碼');
      }
      if (this.newPassword1 != this.newPassword2)
        throw new Error('兩次密碼不符');
    },
    goBack() {
      // window.window.history.go(-1)
      window.history.go(-1)
      
    }
  },
}

</script>
<style lang="scss">


</style>



// WEBPACK FOOTER //
// Chpass.vue?b8f2c98a